import styled from "styled-components";

import { ModalContent } from "uikit";

export const Container = styled.div``;

export const StyledModalContent = styled(ModalContent)`
  text-align: center;
`;
